import { AlertTriangle } from '@crehana/compass.icons.outline/v2/alert-triangle';
import { Award } from '@crehana/compass.icons.outline/v2/award';
import { Book } from '@crehana/compass.icons.outline/v2/book';
import { Calendar } from '@crehana/compass.icons.outline/v2/calendar';
import { CheckmarkCircle } from '@crehana/compass.icons.outline/v2/checkmark-circle';
import { Clock } from '@crehana/compass.icons.outline/v2/clock';
import { Goal } from '@crehana/compass.icons.outline/v2/goal';
import { TrendingUp } from '@crehana/compass.icons.outline/v2/trending-up';

import type { TKeys } from '../../i18n/types';
import type { TIconComponent, TTeamMetricId } from './types';

type TTeamMetricDefinition = {
  id: TTeamMetricId;
  labelKey: TKeys;
  descriptionKey: TKeys;
  icon: TIconComponent;
  /** Token `{{equipo_*}}` mostrado dentro de la tarjeta del bloque (E-7). */
  token: string;
};

/**
 * Catálogo de la sección de switches (E-1..E-4, ANLT-708): 8 métricas,
 * copy, orden e ícono fieles al wireframe (`[VERIF · recon ·
 * decodificación del bundle JS, 2026-08-28]`, `846838ff…js:113-120` — el
 * array `TEAM_METRICS` que alimenta `.rep-metric`, NO el de inserción de
 * variables de `:98-106`). `VARIABLES_EQUIPO` (`catalogo/variables.ts`)
 * trae 10 ids porque también sirve a la inserción de chips `{{ }}` en el
 * texto del correo; el panel de switches del wireframe sólo muestra 8 —
 * `equipo_finalizacion_pct` y `equipo_avance_delta` no están ahí, así que
 * no aparecen en este catálogo (siguen siendo insertables como variable
 * de texto vía `VARIABLES_EQUIPO`, fuera de este archivo).
 */
export const TEAM_METRICS_CATALOG: TTeamMetricDefinition[] = [
  {
    id: 'equipo_avance_pct',
    labelKey: 'METRICS_LABEL_AVANCE_PCT',
    descriptionKey: 'METRICS_DESC_AVANCE_PCT',
    icon: TrendingUp,
    token: '{{equipo_avance_pct}}',
  },
  {
    id: 'equipo_completados_pct',
    labelKey: 'METRICS_LABEL_COMPLETADOS_PCT',
    descriptionKey: 'METRICS_DESC_COMPLETADOS_PCT',
    icon: CheckmarkCircle,
    token: '{{equipo_completados_pct}}',
  },
  {
    id: 'equipo_activos_pct',
    labelKey: 'METRICS_LABEL_ACTIVOS_PCT',
    descriptionKey: 'METRICS_DESC_ACTIVOS_PCT',
    icon: Calendar,
    token: '{{equipo_activos_pct}}',
  },
  {
    id: 'equipo_meta_pct',
    labelKey: 'METRICS_LABEL_META_PCT',
    descriptionKey: 'METRICS_DESC_META_PCT',
    icon: Goal,
    token: '{{equipo_meta_pct}}',
  },
  {
    id: 'equipo_sin_iniciar_pct',
    labelKey: 'METRICS_LABEL_SIN_INICIAR_PCT',
    descriptionKey: 'METRICS_DESC_SIN_INICIAR_PCT',
    icon: AlertTriangle,
    token: '{{equipo_sin_iniciar_pct}}',
  },
  {
    id: 'equipo_riesgo_pct',
    labelKey: 'METRICS_LABEL_RIESGO_PCT',
    descriptionKey: 'METRICS_DESC_RIESGO_PCT',
    icon: Clock,
    token: '{{equipo_riesgo_pct}}',
  },
  {
    id: 'equipo_horas_prom',
    labelKey: 'METRICS_LABEL_HORAS_PROM',
    descriptionKey: 'METRICS_DESC_HORAS_PROM',
    icon: Book,
    token: '{{equipo_horas_prom}}',
  },
  {
    id: 'equipo_cursos_prom',
    labelKey: 'METRICS_LABEL_CURSOS_PROM',
    descriptionKey: 'METRICS_DESC_CURSOS_PROM',
    icon: Award,
    token: '{{equipo_cursos_prom}}',
  },
];
